



















import Vue from "vue";

/**
 * Chat container does not need as much flexibility as JzContainer. However,
 * styling of .jz-chat-container must inherit from .jz-container for
 * consistency
 */
interface Props {
  fill?: boolean;
  overflowYAuto?: boolean;
}

/**
 * This chat container is the default styling for
 * - container sizing
 * - inter-message styling (margin and such)
 */
export default Vue.extend<Props>({
  name: "JzChatContainer",
  functional: true,
  props: {
    fill: { type: Boolean, default: false },
    overflowYAuto: { type: Boolean, default: true }
  }
});
